export default uri => ({
  url: uri,
  method: "GET"
});
